import React, { useState, useRef, useEffect } from 'react';
import Header from '@components/customise/option/header';
import ColourPicker from '../colourpicker';
import Typography from '@components/typography';
import { getVehicleColourOptions } from '@store/reducers/vehiclecolouroptions';
import { useVehicle } from '@hooks/usevehicle';
import cn from 'classnames';
import { Vehicle } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehicle';
import { VehicleColourProps } from 'interface';
import { useAppSelector, useAppDispatch } from '@hooks/statehooks';
import { getMatchedPrices } from './helper';

import '@styles/customise/option.scss';

const Paint: React.FC<VehicleColourProps> = ({
  currentStep,
  totalSteps,
  options,
  children,
}) => {
  const [info, setInfo] = useState<{
    url: string | undefined | null;
    description: string | undefined | null;
  }>({
    url: '',
    description: '',
  });

  const { vehicleDetails } = useVehicle();

  const { modelCode, doors, train, year, trim, model, make } =
    vehicleDetails as Vehicle;
  const hasFetchedData = useRef(false);
  const dispatch = useAppDispatch();
  const vehicleColourOptions = useAppSelector(
    (state) => state.vehicleColourOptions
  );

  useEffect(() => {
    if (!hasFetchedData.current) {
      if (
        modelCode &&
        vehicleColourOptions.colourList.length === 0 &&
        !vehicleColourOptions.error &&
        !vehicleColourOptions.loading
      ) {
        dispatch(
          getVehicleColourOptions({ modelCode, doors, trim, train, year })
        );
      }
    }
  }, [modelCode, trim, doors, train, year]);

  return (
    <div className="customise-options__paint">
      <div
        className={cn(
          'customise-options__content',
          vehicleColourOptions.colourList &&
            vehicleColourOptions.colourList.length > 0
            ? 'colour-picker'
            : ''
        )}
      >
        {vehicleColourOptions.colourList &&
          vehicleColourOptions.colourList.length !== 0 &&
          getMatchedPrices(options, vehicleColourOptions.colourList).filter(
            (x) => x.hasOwnProperty('hexCode')
          ).length !== 0 && (
            <div className="customise-options__row-content">
              <div
                className={cn(
                  'customise-options__content-image',
                  !info.url ? 'no-image' : ''
                )}
              >
                {info.url ? (
                  <>
                    <img
                      src={info.url}
                      alt={
                        info.description
                          ? `${make} ${model} in ${info.description}`
                          : 'No colour description'
                      }
                      data-cy="customise-options__content-image"
                    />
                  </>
                ) : (
                  <Typography
                    variant="caption"
                    size="3x"
                    weight="bold"
                    data-cy="customise-options__content-no-image-description"
                  >
                    No Image Available
                  </Typography>
                )}

                <Typography
                  variant="caption"
                  size="2x"
                  weight="bold"
                  className="customise-options__content-image-description"
                  data-cy="customise-options__content-image-description"
                >
                  {info.description}
                </Typography>
              </div>
            </div>
          )}
        {!vehicleColourOptions.loading && (
          <div className="customise-options__row-header">
            {children}
            <Header
              currentStep={currentStep}
              totalSteps={totalSteps}
              title="Exterior Paint"
              showWarning={true}
              className={cn(
                vehicleColourOptions.colourList &&
                  vehicleColourOptions.colourList.length !== 0
                  ? 'customise-options__header-paint'
                  : ''
              )}
            />
          </div>
        )}
        <div
          className={cn(
            !vehicleColourOptions.loading && 'customise-options__row-picker'
          )}
        >
          <ColourPicker
            coloursPrices={options}
            onClick={setInfo}
            colourList={vehicleColourOptions.colourList || []}
            isLoading={vehicleColourOptions.loading}
          />
        </div>
      </div>
    </div>
  );
};

export default Paint;
